import { useState, useEffect, useCallback } from 'react';
import {
  getNotificationSettings,
  updateNotificationSettings,
  type NotificationSettings as SettingsType,
} from '../lib/api';
import { haptic } from '../utils/haptic';
import { IconHeart, IconMail, IconChart } from './icons';
import './NotificationSettings.css';

const ITEMS = [
  {
    key: 'reactions_enabled' as const,
    icon: <IconHeart size={20} />,
    label: 'Реакции на проекты',
    desc: 'Когда кто-то реагирует на ваш проект',
  },
  {
    key: 'requests_enabled' as const,
    icon: <IconMail size={20} />,
    label: 'Заявки по стеку',
    desc: 'Новые заявки, совпадающие с вашим стеком',
  },
  {
    key: 'weekly_digest_enabled' as const,
    icon: <IconChart size={20} />,
    label: 'Еженедельный дайджест',
    desc: 'Статистика и лучшие проекты недели',
  },
] as const;

export function NotificationSettings({ hideHeader }: { hideHeader?: boolean }) {
  const [settings, setSettings] = useState<SettingsType>({
    reactions_enabled: true,
    requests_enabled: true,
    weekly_digest_enabled: true,
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getNotificationSettings()
      .then((data) => {
        setSettings(data);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  const toggle = useCallback(
    async (key: keyof SettingsType) => {
      haptic.select();
      const updated = { ...settings, [key]: !settings[key] };
      setSettings(updated);
      try {
        await updateNotificationSettings(updated);
      } catch {
        // revert on error
        setSettings(settings);
      }
    },
    [settings],
  );

  if (!loaded) return null;

  return (
    <div className="notification-settings">
      {!hideHeader && <div className="profile-section-header">Уведомления</div>}
      {ITEMS.map((item) => (
        <div
          key={item.key}
          className="notification-toggle"
          onClick={() => toggle(item.key)}
        >
          <span className="notification-toggle-icon" aria-hidden>{item.icon}</span>
          <div className="notification-toggle-content">
            <div className="notification-toggle-label">{item.label}</div>
            <div className="notification-toggle-desc">{item.desc}</div>
          </div>
          <div className={`notification-switch ${settings[item.key] ? 'on' : 'off'}`}>
            <div className="notification-switch-thumb" />
          </div>
        </div>
      ))}
    </div>
  );
}
